import './App.css';
import './global-variables.scss';
import './pages/home.scss';

import { useEffect } from 'react';



import Navbar from './navbar.js';
import Footer from './footer.js';
import ErrorPage from './pages/error-page.js';
import React, { useState } from 'react';
import Home from './pages/home.js';
import TimeSelect from './pages/time-select.js';
import Profile from './pages/profile.js';
import PreTest from './pages/pre-test.js';
import PremiumTest from './pages/premium-test.js';
import Results from './pages/results.js';
import Test from './pages/test.js';
import About from './pages/about.js';
import Success from './pages/success.js';
import Failure from './pages/failure.js';
import ResultChart from './components/result-chart';
import Modal from './components/modal';

import SwitchPremium from './util/switch-premium';

import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';

import { useUser } from './hooks/useUser';
import ScrollToTop from './hooks/scrollToTop';


import { getAuth, getRedirectResult, GoogleAuthProvider } from 'firebase/auth';
import { doc, getDoc, updateDoc, collection, getDocs } from 'firebase/firestore';
import { firebaseApp, firebaseDB, firebaseAnalytics } from './firebase';

import { motion } from 'framer-motion';


import { useFirebaseServices } from './hooks/firebase-services.js';




function App() {

  const location = useLocation;

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [premiumModalOpen, setPremiumModalOpen] = useState(false);
  const [personalityData, setPersonalityData] = useState(null);
  const [priceAmount, setPriceAmount] = useState(0);
  const [currency, setCurrency] = useState(null);
  const [signUpFlow, setSignUpFlow] = useState(null);

  //const [ loading, setLoading ] = useState(true);
  //const { user } = useUser();
  const { user, userLoading } = useUser();
  const [dataLoading, setDataLoading] = useState(true);

  const [userData, setUserData] = useState(null);
  const [isPaid, setPaid] = useState(false);

  const navigate = useNavigate();
  const auth = getAuth();

  const { fetchProducts, checkPaidStatus, checkout } = useFirebaseServices(setPaid, setPriceAmount, setCurrency);

  fetchProducts();




  // This is for getting the auth result from the google redirect
  getRedirectResult(auth)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access Google APIs.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;

      // The signed-in user info.
      const user = result.user;
      // IdP data available using getAdditionalUserInfo(result)
      // ...
    }).catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      //const email = error.customData.email;
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
      // ...
    });


  /**
   * Checks any time modal is open to prevent scrolling on body
   */
  useEffect(() => {

    if (deleteModalOpen || premiumModalOpen == true) {
      document.body.style.overflow = "hidden";
    }
    else {
      document.body.style.overflow = "auto";
    }
  }, [deleteModalOpen, premiumModalOpen]);


  // check personality data any time user has changed
  useEffect(() => {
    setDataLoading(true);
    checkData();
    //setLoading(false);

  }, [user]);

  useEffect(() => {

    fetchProducts();
    checkPaidStatus();

  }, [user]);


  const checkData = async () => {
    try {
      //check if there is a user logged in
      if (user != null) {
        const docRef = doc(firebaseDB, "users", user.uid);
        const docSnap = await getDoc(docRef);
        // if there is associated data with the user
        if (docSnap.exists()) {
          localStorage.clear();
          setUserData(docSnap.data());
          //setPaid(docSnap.data().isPaid);
          if (docSnap.data().personalityData != null) {
            const personality = docSnap.data().personalityData;
            //console.log("Document data:", docSnap.data());
            setPersonalityData(
              // "ope": personality.ope, "con": personality.con, "ext": personality.ext,
              // "agr": personality.agr, "sta": personality.sta
              personality
            );
            //navigate('/results');

            //console.log("Found personality data" + user.uid);
          }
          else {
            //console.log("Personality data is null!");
          }
        }
        else {
          // docSnap.data() will be undefined in this case
          //console.log("No such document!");
        }
      }


      // if there is not a user logged in, then we check if there is data in local storage. 
      const localPersonalityData = localStorage.getItem("personalityData");

      //console.log(localPersonalityData);

      if (localPersonalityData != null) {

        const parsedPersonalityData = JSON.parse(localPersonalityData);

        //console.log(parsedPersonalityData.ope);
        //console.log(localPersonalityData.ope);
        //console.log(parsedPersonalityData);

        setPersonalityData(
          parsedPersonalityData
        );


        //console.log("got local data")
        //navigate('/results');

      }


    } catch (err) {
      console.log(err);
    }
    finally {
      setDataLoading(false);
    }

  }

  //const loading = ( userLoading == true ) || ( dataLoading == true );
  const loading = dataLoading;





  return (
    // the basename prop is so that i can deploy on github - might need to remove later on

    // I have removed "basename" prop from this - if need to add back in, use basename="big-five"
    <>
      <ScrollToTop />
      <div className="App"  >
        {/*< SwitchPremium setPaid={setPaid} />*/}
        <Navbar completedTestExists={personalityData != null ? true : false} />
        <div className="app-body">


          < Modal loading={loading} deleteModalOpen={deleteModalOpen} setDeleteModalOpen={setDeleteModalOpen} premiumModalOpen={premiumModalOpen} setPremiumModalOpen={setPremiumModalOpen}
            setPersonalityData={setPersonalityData} setSignUpFlow={setSignUpFlow} priceAmount={priceAmount} currency={currency} />

          <Routes>

            <Route path="/" element={<Home completedTestExists={personalityData != null ? true : false} loading={loading} />}
              errorElement={<ErrorPage />} />
            <Route path="/profile" element={<Profile personalityData={personalityData} setPersonalityData={setPersonalityData}
              setDeleteModalOpen={setDeleteModalOpen} signUpFlow={signUpFlow} setSignUpFlow={setSignUpFlow} />} />
            <Route path="/time-select" element={<TimeSelect />} />
            <Route path="/pre-test" element={<PreTest priceAmount={priceAmount} currency={currency} isPaid={isPaid} setSignUpFlow={setSignUpFlow} />} />
            <Route path="/premium-test" element={<PremiumTest priceAmount={priceAmount} currency={currency} setSignUpFlow={setSignUpFlow} setPremiumModalOpen={setPremiumModalOpen} />} />
            <Route path="/test" element={<Test setPersonalityData={setPersonalityData} />} />
            <Route path="/results" element={<Results personalityData={personalityData} setDeleteModalOpen={setDeleteModalOpen} setPremiumModalOpen={setPremiumModalOpen} loading={loading} isPaid={isPaid} />} />
            <Route path="/result-chart" element={<div style={{ marginLeft: "auto", marginRight: "auto" }}><ResultChart facetType="con" level={2} /></div>} />
            <Route path="/about" element={<About />} />
            <Route path="/success" element={<Success completedTestExists={personalityData != null ? true : false} loading={loading} user={user} />} />
            <Route path="/failure" element={<Failure completedTestExists={personalityData != null ? true : false} loading={loading} user={user} />} />
            <Route path="*" element={<Home />} />

          </Routes>
        </div>
        <Footer />
      </div>
    </>

  );
}



export default App;
